import { module as Module } from "modujs";
import { $screen } from "../stores/screen.js";

export default class Cover extends Module {
    constructor(m) {
        super(m);

        // Binding
        this.onResizeBind = this.onResize.bind(this);

        // UI
        this.$parallaxElement = this.$("parallax")[0];

        // Data
        this.wHeight = window.innerHeight;
        this.parallaxSpeed = parseFloat(
            this.$parallaxElement?.dataset?.scrollSpeed
        );
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents();
        this.computeScale();
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        if (this.wHeight && this.parallaxSpeed) {
            this.unbindScreenListener = $screen.subscribe(this.onResizeBind);
        }
    }

    unbindEvents() {
        this.unbindScreenListener?.();
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize({ height }) {
        this.wHeight = height;
        this.computeScale();
    }

    ///////////////
    // Methods
    ///////////////
    computeScale() {
        const elHeight = this.el.offsetHeight;
        const distance = Math.abs((this.wHeight * this.parallaxSpeed) / 3);
        this.el.style.setProperty("--parallax-height", `${distance + elHeight}px`);
    }
}
